module.exports = __webpack_public_path__ + "img/vickyc5_thumbnail.a91eee13.jpg";